import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Home from "./components/Home";

function Routes() {
  return (
    <BrowserRouter>
      <Route exact path="/">
        <Home />
      </Route>
    </BrowserRouter>
  );
}

export default Routes;
